import { ITerminalDto } from "./TerminalDto";

export interface ITerminalsDto {
  terminals: ITerminalDto[] | null;
}

export class TerminalsDto implements ITerminalsDto {
  public terminals: ITerminalDto[];
  constructor(terminals: Array<ITerminalDto> = new Array<ITerminalDto>()) {
    this.terminals = terminals;
  }
}